var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InteractionsServiceConstants, SERVICE } from "@agentx/agentx-services";
import { action, makeObservable, observable } from "mobx";
import { logger } from "../logger/store-logger";
const INTERACTIONS_CLEANUP_DELAY = 1000;
function contactRoutingStateMapping(taskContactRoutingState, targetContactRoutingState, timestamp) {
    return taskContactRoutingState === targetContactRoutingState
        ? { duration: timestamp, createdTime: timestamp, isActive: true }
        : { duration: 0, createdTime: 0, isActive: false };
}
export function mapServiceToStoreData(task) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    let customerId = "";
    if (task.direction === "inbound") {
        customerId = task.origin;
    }
    else if (task.direction === "outdial") {
        customerId = task.destination;
    }
    const handleTime = contactRoutingStateMapping(task.contactRoutingState, InteractionsServiceConstants.ContactRoutingState.Assigned, task.contactRoutingStateTimestamp);
    const waitTime = contactRoutingStateMapping(task.contactRoutingState, InteractionsServiceConstants.ContactRoutingState.Queued, task.contactRoutingStateTimestamp);
    return {
        id: task.id,
        channel: {
            channelType: task.channelType,
            channelSubType: task.channelSubType ? task.channelSubType : undefined
        },
        startTime: task.createdTime,
        endTime: task.endedTime,
        customerName: (_a = task.customer) === null || _a === void 0 ? void 0 : _a.name,
        customerId,
        direction: task.direction,
        entryPoint: (_b = task.lastEntryPoint) === null || _b === void 0 ? void 0 : _b.name,
        queue: (_c = task.lastQueue) === null || _c === void 0 ? void 0 : _c.name,
        team: (_d = task.lastTeam) === null || _d === void 0 ? void 0 : _d.name,
        site: (_e = task.lastSite) === null || _e === void 0 ? void 0 : _e.name,
        contactStatus: task.status,
        agent: {
            name: (_f = task.lastAgent) === null || _f === void 0 ? void 0 : _f.name,
            email: (_g = task.lastAgent) === null || _g === void 0 ? void 0 : _g.signInId
        },
        csat: task.csatScore,
        handleTime,
        transfers: task.transferCount,
        blindTransfers: task.blindTransferCount,
        holdTime: { duration: (_h = task.holdDuration) !== null && _h !== void 0 ? _h : 0 },
        timestamp: task.lastActivityTime,
        wrapUpTime: { duration: (_j = task.wrapupDuration) !== null && _j !== void 0 ? _j : 0 },
        totalContactDuration: {
            duration: task.totalDuration,
            createdTime: task.totalDuration,
            isActive: true
        },
        recipients: (_l = (_k = task.emailToList) === null || _k === void 0 ? void 0 : _k.split(";")) !== null && _l !== void 0 ? _l : [],
        ccRecipients: (_o = (_m = task.emailCcList) === null || _m === void 0 ? void 0 : _m.split(";")) !== null && _o !== void 0 ? _o : [],
        emailSubject: (_q = (_p = task.channelMetaData) === null || _p === void 0 ? void 0 : _p.email) === null || _q === void 0 ? void 0 : _q.subject,
        wrapUpReason: task.lastWrapupCodeName,
        consultingAgents: task.consultCount,
        conferencingAgents: task.conferenceCount,
        skills: (_r = task.requiredSkills) === null || _r === void 0 ? void 0 : _r.map((skill) => skill.name),
        queuedFrom: (_s = task.previousQueue) === null || _s === void 0 ? void 0 : _s.name,
        transferredToQueue: task.agentToQueueTransferCount,
        transferredByAgent: task.previousAgentName,
        waitTime,
        hasRecording: task.captureRequested && !task.isRecordingDeleted,
        agentId: (_t = task.lastAgent) === null || _t === void 0 ? void 0 : _t.id,
        agentPhoneNumber: (_u = task.lastAgent) === null || _u === void 0 ? void 0 : _u.phoneNumber,
        lastQueueId: (_v = task.lastQueue) === null || _v === void 0 ? void 0 : _v.id,
        wrapUpCodeId: task.lastWrapUpCodeId,
        customerEmail: (_w = task.customer) === null || _w === void 0 ? void 0 : _w.email,
        customerPhoneNumber: (_x = task.customer) === null || _x === void 0 ? void 0 : _x.phoneNumber,
        origin: task.origin,
        isActive: task.isActive,
        contactRoutingState: task.contactRoutingState
    };
}
export class InteractionsStore {
    constructor() {
        this.selectedInteraction = undefined;
        this.selectedTab = undefined;
        //observable.map was chosen to allow for a simpler integration with AGGrid, do not use unless you have a similar requirement
        this.activeInteractions = observable.map();
        this.queuedInteractions = observable.map();
        this.completedInteractions = observable.map();
        this.cleanupTimerId = undefined;
        this.subscriptionIsInProgress = false;
        this.subscriptionId = undefined;
        makeObservable(this);
    }
    subscribeToInteractions() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cleanupTimerId) {
                clearTimeout(this.cleanupTimerId);
                this.cleanupTimerId = undefined;
            }
            if (this.subscriptionId || this.subscriptionIsInProgress) {
                return; // Already subscribed
            }
            this.subscriptionIsInProgress = true;
            try {
                const updateCallback = this.createUpdateCallbackFunc();
                const subscriptionId = yield SERVICE.interactions.subscribeInteractionUpdates(updateCallback);
                this.subscriptionId = subscriptionId;
                this.subscriptionIsInProgress = false;
            }
            catch (error) {
                logger.error("Error subscribing to interactions", error);
                this.subscriptionIsInProgress = false;
                throw error;
            }
        });
    }
    stopInteractionUpdates() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.subscriptionId) {
                if (this.cleanupTimerId) {
                    clearTimeout(this.cleanupTimerId);
                }
                this.cleanupTimerId = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    this.cleanInteractionsMaps();
                    this.cleanupTimerId = undefined;
                    if (this.subscriptionId) {
                        try {
                            yield SERVICE.interactions.stopInteractionUpdates(this.subscriptionId);
                            this.subscriptionId = undefined;
                        }
                        catch (error) {
                            logger.error("Error stopping interaction updates", error);
                        }
                    }
                }), INTERACTIONS_CLEANUP_DELAY);
            }
        });
    }
    cleanInteractionsMaps() {
        this.getInteractionsMap(InteractionsServiceConstants.QueryType.Active).clear();
        this.getInteractionsMap(InteractionsServiceConstants.QueryType.Queued).clear();
    }
    fetchCompletedInteractions(startTime, endTime, sortBy, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentQuery = { startTime, endTime, sortBy, filters };
            if (JSON.stringify(this.lastCompletedInteractionsQuery) === JSON.stringify(currentQuery)) {
                if (this.completedNextPage) {
                    return this.completedNextPage();
                }
                return false;
            }
            this.lastCompletedInteractionsQuery = currentQuery;
            this.completedInteractions.clear();
            try {
                const { fetchMore } = yield SERVICE.interactions.fetchCompletedInteractions(startTime, endTime, (data) => this.handleCompletedCallback(data), sortBy, filters);
                this.completedNextPage = fetchMore !== null && fetchMore !== void 0 ? fetchMore : null;
                return fetchMore !== null;
            }
            catch (error) {
                logger.error("Error fetching completed interactions.", error.message);
                throw error;
            }
        });
    }
    setSelectedInteraction(interactionId) {
        if (interactionId !== "") {
            const activeInteraction = this.activeInteractions.get(interactionId);
            if (activeInteraction) {
                this.selectedInteraction = activeInteraction;
                this.selectedTab = InteractionsServiceConstants.QueryType.Active;
                return;
            }
            const queuedInteraction = this.queuedInteractions.get(interactionId);
            if (queuedInteraction) {
                this.selectedInteraction = queuedInteraction;
                this.selectedTab = InteractionsServiceConstants.QueryType.Queued;
                return;
            }
            const completedInteraction = this.completedInteractions.get(interactionId);
            if (completedInteraction) {
                this.selectedInteraction = completedInteraction;
                this.selectedTab = InteractionsServiceConstants.QueryType.Completed;
                return;
            }
        }
        else {
            this.selectedInteraction = undefined;
            this.selectedTab = undefined;
        }
    }
    handleCompletedCallback(data) {
        data.forEach((interaction) => {
            this.completedInteractions.set(interaction.id, mapServiceToStoreData(interaction));
        });
    }
    createUpdateCallbackFunc() {
        return (data) => {
            var _a;
            if (data.fullUpdate) {
                this.handleFullUpdate(data.fullUpdate);
            }
            else if (data.realTimeUpdate) {
                this.handleUpdate(data.realTimeUpdate.updated);
            }
            if ((_a = data.realTimeUpdate) === null || _a === void 0 ? void 0 : _a.removed) {
                this.handleRemove(data.realTimeUpdate.removed);
            }
        };
    }
    handleFullUpdate(fullUpdate) {
        const assignedTasks = fullUpdate.filter((item) => item.contactRoutingState === "Assigned");
        this.activeInteractions = observable.map(assignedTasks.map((item) => [item.id, mapServiceToStoreData(item)]));
        const queuedTasks = fullUpdate.filter((item) => item.contactRoutingState === "Queued");
        this.queuedInteractions = observable.map(queuedTasks.map((item) => [item.id, mapServiceToStoreData(item)]));
    }
    handleUpdate(update) {
        var _a, _b, _c;
        //TODO: This logic needs to move into the service layer
        const tasksByState = update.reduce((acc, task) => {
            const state = task.contactRoutingState ||
                InteractionsServiceConstants.ContactRoutingState.Other;
            acc[state] = acc[state] || [];
            acc[state].push(task);
            return acc;
        }, {});
        if ((_a = tasksByState.Other) === null || _a === void 0 ? void 0 : _a.length) {
            for (const task of tasksByState.Other) {
                this.queuedInteractions.delete(task.id);
                this.activeInteractions.delete(task.id);
            }
        }
        if ((_b = tasksByState.Assigned) === null || _b === void 0 ? void 0 : _b.length) {
            for (const task of tasksByState.Assigned) {
                this.queuedInteractions.delete(task.id);
            }
            this.updateInteractionsMap(this.activeInteractions, tasksByState.Assigned);
        }
        if ((_c = tasksByState.Queued) === null || _c === void 0 ? void 0 : _c.length) {
            this.updateInteractionsMap(this.queuedInteractions, tasksByState.Queued);
        }
    }
    handleRemove(removed) {
        this.updateInteractionsMap(this.activeInteractions, undefined, removed);
        this.updateInteractionsMap(this.queuedInteractions, undefined, removed);
    }
    getInteractionsMap(queryType) {
        return queryType === InteractionsServiceConstants.QueryType.Active
            ? this.activeInteractions
            : this.queuedInteractions;
    }
    updateInteractionsMap(targetMap, updated, removed) {
        if (updated) {
            updated.forEach((interaction) => {
                targetMap.set(interaction.id, mapServiceToStoreData(interaction));
            });
        }
        if (removed) {
            removed.forEach((interactionId) => {
                targetMap.delete(interactionId);
            });
        }
    }
}
__decorate([
    observable
], InteractionsStore.prototype, "selectedInteraction", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "selectedTab", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "activeInteractions", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "queuedInteractions", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "completedInteractions", void 0);
__decorate([
    action
], InteractionsStore.prototype, "subscribeToInteractions", null);
__decorate([
    action
], InteractionsStore.prototype, "stopInteractionUpdates", null);
__decorate([
    action
], InteractionsStore.prototype, "cleanInteractionsMaps", null);
__decorate([
    action
], InteractionsStore.prototype, "fetchCompletedInteractions", null);
__decorate([
    action
], InteractionsStore.prototype, "setSelectedInteraction", null);
__decorate([
    action
], InteractionsStore.prototype, "handleCompletedCallback", null);
__decorate([
    action
], InteractionsStore.prototype, "handleFullUpdate", null);
__decorate([
    action
], InteractionsStore.prototype, "handleUpdate", null);
__decorate([
    action
], InteractionsStore.prototype, "handleRemove", null);
__decorate([
    action
], InteractionsStore.prototype, "updateInteractionsMap", null);
